<h6>Define Item Options</h6>

<p-table #dt1 [value]="value" [rowHover]="true" styleClass="p-datatable-gridlines" responsiveLayout="scroll"
  editMode="row" dataKey="Id">
  <ng-template pTemplate="caption">
    <div class="flex sm:flex-row">
      <button pButton label="Add" class="p-button-outlined mr-2" icon="pi pi-plus" (click)="addItem()"></button>
      @if(save.observed){
      <button pButton label="Save" icon="pi pi-save mr-2" (click)="save.emit(value)"></button>
      }
    </div>
  </ng-template>

  <ng-template pTemplate="header">
    <tr>
      <th></th>
      <th>Type</th>
      <th>Name</th>
      <th>Is Variation?</th>
      <th>Min Selection</th>
      <th>Max Selection</th>
      <th>Free Selection</th>
      <th>Choices</th>
      <th class="tw-px-0"></th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-option let-editing="editing" let-ri="rowIndex">
    <tr [pEditableRow]="option" [pReorderableRow]="ri">
      <td class="align-center">
        <span class="pi pi-bars" pReorderableRowHandle></span>
      </td>
      <td>
        <p-cellEditor>
          <ng-template pTemplate="input">
            <p-dropdown [options]="types" appendTo="body" [(ngModel)]="option.Type"></p-dropdown>
          </ng-template>
          <ng-template pTemplate="output">{{option.Type}}</ng-template>
        </p-cellEditor>
      </td>
      <td>
        <p-cellEditor>
          <ng-template pTemplate="input">
            <input pInputText type="text" [(ngModel)]="option.Name" [placeholder]="'Choose '+ option.Type">
          </ng-template>
          <ng-template pTemplate="output">{{option.Name}}</ng-template>
        </p-cellEditor>
      </td>
      <td>
        <p-cellEditor>
          <ng-template pTemplate="input">
            <p-checkbox binary="true" name="is-variation" [(ngModel)]="option.IsVariation"></p-checkbox>
          </ng-template>
          <ng-template pTemplate="output">{{option.IsVariation}}</ng-template>
        </p-cellEditor>
      </td>
      <td>
        <p-cellEditor>
          <ng-template pTemplate="input">
            <input pInputText type="number" [(ngModel)]="option.MinSelection" style="width: 5rem">
          </ng-template>
          <ng-template pTemplate="output">{{option.MinSelection}}</ng-template>
        </p-cellEditor>
      </td>
      <td>
        <p-cellEditor>
          <ng-template pTemplate="input">
            <input pInputText type="number" [(ngModel)]="option.MaxSelection" style="width: 5rem">
          </ng-template>
          <ng-template pTemplate="output">{{option.MaxSelection}}</ng-template>
        </p-cellEditor>
      </td>
      <td>
        <p-cellEditor>
          <ng-template pTemplate="input">
            <input pInputText type="number" [(ngModel)]="option.FreeSelection" style="width: 5rem">
          </ng-template>
          <ng-template pTemplate="output">{{option.FreeSelection}}</ng-template>
        </p-cellEditor>
      </td>
      <td>
        <button type="button" pButton pRipple severity="warning" class="p-button-rounded p-button-plain"
          (click)="selected=option;choiceDialog=true">
          {{option.Choices?.length||0}} Choice(s)</button>
      </td>
      <td class="tw-px-0">
        <div class="flex align-items-center justify-content-center gap-2">
          <button *ngIf="!editing" pButton pRipple type="button" pInitEditableRow icon="pi pi-pencil"
            class="p-button-rounded p-button-text btn-min"></button>
          <button *ngIf="!editing" pButton pRipple type="button" icon="pi pi-trash"
            class="p-button-rounded p-button-text btn-min p-button-danger" (click)="removeItem(ri)"></button>
          <button *ngIf="editing" pButton pRipple type="button" pSaveEditableRow icon="pi pi-check"
            class="p-button-rounded p-button-text btn-min p-button-success mr-2"></button>
          <button *ngIf="editing" pButton pRipple type="button" pCancelEditableRow icon="pi pi-times"
            class="p-button-rounded p-button-text btn-min p-button-danger"></button>
        </div>
      </td>
    </tr>
  </ng-template>
</p-table>

<p-dialog *ngIf="selected" [header]="selected.Name||''+ ' Choices'" [(visible)]="choiceDialog" [modal]="true"
  [maximizable]="true" appendTo="body" [style]="{'min-width': '50vw'}" >
  @if(save.observed){ <brt-menu-item-option-choice [(ngModel)]="selected.Choices" [type]="selected.Type"
    (save)="save.emit(value);choiceDialog=false"></brt-menu-item-option-choice>
  } @else { <brt-menu-item-option-choice [(ngModel)]="selected.Choices"
    [type]="selected.Type"></brt-menu-item-option-choice>
  }

</p-dialog>